import { Link } from "react-router-dom";

/** The 404 for an unknown route. Shared by the staff app and the portal, so
 *  nothing here may import the staff auth context. */
export function NotFound() {
  return (
    <CenteredMessage
      title="Page not found"
      body="That link doesn't lead anywhere in CE Hub. It may have moved, or never existed."
    />
  );
}

/** A centred title and sentence with a way back — the shape of every dead end. */
export function CenteredMessage({ title, body }: { title: string; body: string }) {
  return (
    <div className="grid min-h-dvh place-items-center p-4 text-center">
      <div className="max-w-md">
        <h1 className="text-display-xs font-semibold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm text-[var(--text-2)]">{body}</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-brand-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-700 focus-visible:focus-ring"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
